module.exports = __webpack_public_path__ + "img/mkv.9c5cbe08.svg";